import './Batch.scss'
import React, {Component} from 'react'
import {Modal, notification, Pagination, Spin} from 'antd'
import {withTranslation} from 'react-i18next'
import {Page, PageBottomBar, PageFooter, PageHeader, PageToolbar, PageTopBar} from '../../layouts/Private/components'
import {getFilesByClientPromise, uploadFilePromise} from './promises'
import {AddButton, File, FilesPageContent, ModalAddBatchFile, SearchFilters} from './components'
import noResultsImg from '../Query/no-results-bg.png'
import {SubclientDropdown} from "../SharedComponents";

class Batch extends Component {
  tmpFilters = {
    resultsCurrentPage: 1,
    resultsPerPage: 17,
    searchFileName: '',
    searchFromDate: '',
    searchOptDates: '',
    searchToDate: '',
    searchUserId: ''
  }

  state = {
    files: [],
    isFiltered: false,
    isLoading: true,
    isUploading: false,
    isModalUploadVisible: false,
    resultsCurrentPage: 1,
    resultsNum: -1,
    resultsPerPage: 17,
    searchFileName: '',
    tmpSearchFileName: '',
    searchFromDate: '',
    tmpSearchFromDate: '',
    searchOptDates: '',
    tmpSearchOptDates: '',
    searchToDate: '',
    tmpSearchToDate: '',
    searchUserId: '',
    tmpSearchUserId: '',
    subclientId: ''
  }

  refreshFiles = setInterval(async () => {
    const { resultsCurrentPage, resultsPerPage, searchFileName, searchOptDates, searchFromDate, searchToDate, searchUserId } = this.state
    const fromNum = (resultsCurrentPage - 1) * resultsPerPage
    const files = await getFilesByClientPromise(fromNum, resultsPerPage, searchFromDate, searchToDate, searchUserId, searchFileName, searchOptDates)

    this.setState({ files: files.files, isLoading: false, resultsNum: files.total })
  }, 1000)


  componentWillUnmount() {
    window.clearInterval(this.refreshFiles)
  }


  handleOpenModalAddFile() {
    this.setState({ isModalUploadVisible: true })
  }

  handleCloseModalAddFile() {
    this.setState({ isModalUploadVisible: false })
  }

  async handlePaginationChange(from) {
    await this.setState({ isLoading: true, resultsCurrentPage: from })
  }

async handleUploadNewFile(file, searchRecordType, searchScope, contents) {
    const { t } = this.props
    const {subclientId} = this.state

    const isSubclientSelected = this.validateSubclientSelection()

    if (isSubclientSelected) {
      if (contents.length === 0) {
        notification['error']({
          message: t('messages.aml.missingRequiredField'),
          description: 'Debe seleccionar bases de datos a consultar'
        })
        return false
      }

      await this.setState({ isUploading: true })

      const formData = new FormData()

      formData.append('file', file)
      formData.append('typeSearch', searchScope)
      formData.append('type', searchRecordType)
      formData.append('contents', contents)
      formData.append('subclienteId', subclientId)


      await this.setState({isUploading: true})

      const upload = await uploadFilePromise(formData)
      const {resultsCurrentPage, resultsPerPage} = this.state
      const fromNum = (resultsCurrentPage - 1) * resultsPerPage

      if (upload.success) {
        const files = await getFilesByClientPromise(fromNum, resultsPerPage)

        await this.setState({
          files: files.files,
          isModalUploadVisible: false,
          isUploading: false,
          resultsCurrentPage: 1,
          resultsNum: files.total
        })

        const div = document.createElement('div')
        const el = document.getElementsByClassName('file')[0]

        div.setAttribute('class', 'white-overlay')

        el.appendChild(div)
      }else {
        notification['error']({
          message: 'Error',
          description: upload.error
        })
      }
    }

      else {
        notification['error']({
          message: 'Error',
          description: 'Para ejecutar una consulta debes seleccionar un Subcliente.'
        })
      }
  }

  handleFromDateChange(tmpSearchFromDate) {
    this.setState({ tmpSearchFromDate })
  }

  handleToDateChange(tmpSearchToDate) {
    this.setState({ tmpSearchToDate })
  }

  handleOptDatesChange(tmpSearchOptDates) {
    this.setState({ tmpSearchOptDates })
  }

  handleUserChange(tmpSearchUserId) {
    this.setState({ tmpSearchUserId })
  }

  handleFileNameChange(e) {
    this.setState({ tmpSearchFileName: e.target.value })
  }

  handleApplyFilters() {
    const { tmpSearchFileName, tmpSearchFromDate, tmpSearchOptDates, tmpSearchToDate, tmpSearchUserId } = this.state

    this.setState({
      isFiltered: true,
      isLoading: true,
      resultsCurrentPage: 1,
      searchFileName: tmpSearchFileName,
      searchFromDate: tmpSearchFromDate,
      searchOptDates: tmpSearchOptDates,
      searchToDate: tmpSearchToDate,
      searchUserId: tmpSearchUserId
    })
  }

  async handleClearFilters() {
    await this.setState({
      isFiltered: false,
      isLoading: true,
      resultsCurrentPage: 1,
      searchFileName: '',
      tmpSearchFileName: '',
      searchFromDate: '',
      tmpSearchFromDate: '',
      searchOptDates: '',
      tmpSearchOptDates: '',
      searchToDate: '',
      tmpSearchToDate: '',
      searchUserId: '',
      tmpSearchUserId: ''
    })
  }

  handleOnChangeSubclient(subclientId) {
    this.setState({ subclientId })
  }

  validateSubclientSelection() {
    const { currentUser } = this.props
    const { subclientId } = this.state
    const hasClients = currentUser.cliente.clientes.length
    const isOutsourcer = currentUser.cliente.outsourcer
    const hasSubclient = currentUser.subcliente !== null

    let isSubclientSelected = true

    if (hasClients && isOutsourcer && !hasSubclient) {
      if (subclientId === '') {
        isSubclientSelected = false
      }
    }

    return isSubclientSelected
  }


  render() {
    const { t, currentUser } = this.props
    const { files, isFiltered, isLoading, isModalUploadVisible, isUploading, resultsCurrentPage, resultsNum, resultsPerPage, searchFileName, searchFromDate, searchOptDates, searchToDate, searchUserId, subclientId } = this.state

    return (
      <div className="batch">
        <PageTopBar breadcrumbs={ [{ title: t('messages.aml.batchProcesses'), icon: 'coffee', link: '/masivos' }] } />
        <Page>
          <PageHeader
            icon="coffee"
            title={ t('messages.aml.batchProcesses')}
            description={ t('messages.aml.batchProcessesDescription') }
          >
          </PageHeader>

          <PageToolbar>
            <SearchFilters
              currentValues={ this.state }
              fileNameHandler={ this.handleFileNameChange.bind(this) }
              userHandler={ this.handleUserChange.bind(this) }
              optDatesHandler={ this.handleOptDatesChange.bind(this) }
              fromDateHandler={ this.handleFromDateChange.bind(this) }
              toDateHandler={ this.handleToDateChange.bind(this) }
              applyHandler={ this.handleApplyFilters.bind(this) }
              clearHandler={ this.handleClearFilters.bind(this) }
            />
          </PageToolbar>
          <FilesPageContent>
            { isLoading ?
                <div className="is-loading">
                  <Spin size="large" spinning={ true } />
                </div>
              : resultsNum === 0 ?
                (
                  isFiltered ?
                    <div className="no-results">
                      <div className="no-results-img-wrapper">
                        <img src={ noResultsImg } alt="" />
                        <h3>No se han encontrado coincidencias.</h3>
                      </div>
                    </div>
                  : currentUser.type !== 'AUDIT' &&
                    <div className="empty">
                      <AddButton onClick={ this.handleOpenModalAddFile.bind(this) } />
                      <h3><span>Haga click para agregar su primera consulta masiva.</span></h3>
                    </div>
                )
              : currentUser.type !== 'AUDIT' &&
                  <>
                    <AddButton onClick={ this.handleOpenModalAddFile.bind(this) } />
                    { files.map(file => <File file={ file } currentUser={currentUser} />) }
                  </>
            }
          </FilesPageContent>
          <PageFooter>
            { resultsNum > 17 && <Pagination defaultCurrent={ 1 } current={ resultsCurrentPage } total={ resultsNum } pageSize={ resultsPerPage } onChange={ this.handlePaginationChange.bind(this) } /> }
          </PageFooter>
        </Page>
        <PageBottomBar breadcrumbs={ [{ title: t('messages.aml.batchProcesses'), icon: 'coffee', link: '/masivos' }] } />
        { isModalUploadVisible &&
          <Modal
            className="modal-add-batch-file"
            title={ null }
            footer={ null }
            onCancel={ this.handleCloseModalAddFile.bind(this) }
            visible={ isModalUploadVisible }
            width={700}
          >
            <ModalAddBatchFile currentUser={currentUser}
                               isUploading={ isUploading }
                               uploadHandler={ this.handleUploadNewFile.bind(this)}
                               handleOnChangeSubclient = {this.handleOnChangeSubclient.bind(this)}
            />
          </Modal>
        }
      </div>
    )
  }
}

export default withTranslation()(Batch)
